// material-ui
import { CircularProgress } from '@mui/material'
import * as localStorageService from 'components/localStorageService'
import { ResolvePath } from 'features/firebase-app'
import { useNavigate } from 'react-router-dom'

import * as applicationSlice from 'features/application/application-slice'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'

import { Views } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import AddProfileButton from 'components/AddProfileButton'
import ProfileHeader from 'components/ProfileHeader'
import ProfileItem from 'components/ProfileItem'
import ProfileList from 'components/ProfileList'
import ProfileListTItle from 'components/ProfileListTItle'
import ProfileScene from 'components/ProfileScene'
import ProfileSection from 'components/ProfileSection'
import ProfileSectionContainer from 'components/ProfileSectionContainer'
import { getUserClaims } from 'features/application/application-slice'
import {
    get_all_profile,
    is_profile_busy,
    setSelectedprofile,
} from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SelectProfileComponent() {
    // Generate Grid
    let dispatch = useDispatch()
    const navigate = useNavigate()
    let claims = useSelector(getUserClaims)
    let profile_list = useSelector(get_all_profile);
    let profile_busy = useSelector(is_profile_busy);

    useEffect(() => {
        if (claims?.fire_user) {
            dispatch(autoThunks.get_profiles({ userId: claims?.fire_user }))
        }
    }, [claims?.fire_user])
    useEffect(() => {
        function storeProfilesInCache(): any {
            if (claims?.user) {
                localStorageService.store(
                    { data: profile_list },
                    `profiles-${claims?.user}`,
                )
            }
        }
        storeProfilesInCache()
    }, [claims?.user, JSON.stringify(profile_list || {})])

    function main(comp: any): any {
        return (() => {
            return (
                <ProfileScene>
                    <ProfileHeader
                        btnTitle={TitleService('Edit Profiles')}
                        onBtnClick={() => {
                            navigate(ResolvePath(`/${Views.EditProfileSelect}`))
                        }}
                    ></ProfileHeader>
                    <ProfileSectionContainer>
                        <ProfileSection>
                            <ProfileListTItle></ProfileListTItle>
                            {profile_busy ? <><CircularProgress size={'4rem'} /></> : <ProfileList>
                                {profile_list?.map((profileItem) => {
                                    return (
                                        <ProfileItem
                                            key={profileItem?.id}
                                            profileImage={
                                                profileItem.profileImageName
                                                    ? SC.resolveImgSrc(
                                                        profileItem.profileImageName,
                                                        150,
                                                    )
                                                    : profileItem.profileImage
                                            }
                                            profileName={profileItem.name}
                                            onClick={() => {
                                                localStorageService.store(
                                                    {
                                                        profileId: profileItem?.id,
                                                        date: Date.now(),
                                                    },
                                                    'ProfileId',
                                                )
                                                dispatch(setSelectedprofile(profileItem.id))
                                                dispatch(
                                                    applicationSlice.setProfileImage(
                                                        profileItem.profileImage,
                                                    ),
                                                )
                                                dispatch(
                                                    applicationSlice.setProfileImageName(
                                                        profileItem.profileImageName,
                                                    ),
                                                )
                                                dispatch(
                                                    applicationSlice.setProfileName(profileItem.name),
                                                )
                                                navigate(ResolvePath(`/${Views.Home}`))
                                            }}
                                        ></ProfileItem>
                                    )
                                })}
                                <AddProfileButton
                                    onClick={() => {
                                        navigate(ResolvePath(`/${Views.AddProfile}`))
                                    }}
                                />
                            </ProfileList>}
                        </ProfileSection>
                    </ProfileSectionContainer>
                </ProfileScene>
            )
        })()
    }

    let output_main = main(null)

    return output_main
}
